/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React, { useState } from 'react';
// useState

import { Button } from 'antd';
import Company from '../reviewComponents/company';
import Contract from '../reviewComponents/contract';
import Pricebreaks from '../reviewComponents/pricebreaks';
import Pricing from '../reviewComponents/pricing';
import Product from '../reviewComponents/product';
import Loading from '../../../components/Loading';

// const { Step } = Steps;
// import { Select, Form, Input, Radio, DatePicker } from 'antd';
// import moment from 'moment';
// import NumberFormat from 'react-number-format';

// import {
//   DownloadOutlined,
//   RightOutlined,
//   LeftOutlined,
// } from '@ant-design/icons';
// // import { Document, Outline, Page } from 'react-pdf';
// import fiftyStates from '../../../config/fiftyStates_copy.json';
// import providence from '../../../config/candianProvinces.json';
// import discountCodes from '../optionsJson/discountCodes.json';

const Header = block => {
  const { data } = block;
  console.log(block);

  const [isLoading, setLoading] = useState(false);

  const validation = async () => {
    setLoading(true);
    const status = await data.validate();
    if (status) {
      setLoading(false);
    }
  };

  const ignoreWarnings = async () => {
    setLoading(true);
    const status = await data.ignoreWarnings();
    if (status) {
      setLoading(false);
    }
  };

  const submit = async () => {
    setLoading(true);
    const status = await data.submit();
    if (status) {
      setLoading(false);
    }
  };

  return (
    <div className="subcomponent-wrapper">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
        }}
      >
        <div className="subcomponent-header">Review</div>
        <div className="wizard-wrapper__subheader_button">
          <Button onClick={validation}>Run Validation</Button>
          <Button onClick={ignoreWarnings}>Ignore Warnings</Button>
          <Button onClick={submit}>Submit</Button>
        </div>
      </div>
      {/* <Steps size="small" current={current} onChange={onChange}>
        {steps.map(item => <Step key={item.title} title={item.title} />)}
      </Steps> */}

      {/* <div className="steps-content">{steps[current].content}</div>
      <div className="steps-action">
        {current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button
            type="primary"
            onClick={() => message.success('Processing complete!')}
          >
            Done
          </Button>
        )}
        {current > 0 && (
          <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
            Previous
          </Button>
        )}
      </div> */}
      {!isLoading && (
        <div>
          <Contract
            data={data.values.dibbsContractInfo || []}
            validation={
              data.values.dibbsQuoteValidationMsgsList.dibbsCompanyInfoGroup ||
              []
            }
            changeMenu={data.changeMenus}
            quoteValues={data.quoteValues}
          />
          <Pricing
            data={data.values.dibbsLinesList || []}
            changeMenu={data.changeMenus}
            validation={
              data.values.dibbsQuoteValidationMsgsList.dibbsContractInfoGroup ||
              []
            }
            quoteValues={data.quoteValues}
          />
          <Pricebreaks
            data={data.values.dibbsPriceBreaksList || []}
            validation={
              data.values.dibbsQuoteValidationMsgsList.dibbsPriceBreaksGroup ||
              []
            }
            changeMenu={data.changeMenus}
            quoteValues={data.quoteValues}
          />
          <Product
            data={data.values.dibbsProductsList || []}
            validation={
              data.values.dibbsQuoteValidationMsgsList.dibbsProductsGroup || []
            }
            quoteValues={data.quoteValues}
            changeMenu={data.changeMenus}
          />
          <Company
            data={data.values.dibbsCompanyInfo || []}
            validation={
              data.values.dibbsQuoteValidationMsgsList.dibbsCompanyInfoGroup ||
              []
            }
            quoteValues={data.quoteValues}
            changeMenu={data.changeMenus}
          />
        </div>
      )}
      {isLoading && (
        <div>
          <Loading text="Running Validation: This might take several minutes" />
        </div>
      )}
      <div className="wizard-button-wrapper">
        <Button
          onClick={() => {
            data.changeMenus('product');
          }}
        >
          Previous
        </Button>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/subcomponents/DibbsReview.jsx